import ImageModal from "@components/ImageModal";
import { useAppState } from "@src/state";
import { useState } from "react";
import { Button, Popup } from "semantic-ui-react";

export default function AppLink({ dashboardCard, post, mini, text, icon }) {
  const { state, dispatch } = useAppState();
  const [inView, setInView] = useState(false);
  if (!dashboardCard) return null;
  const scrapedUrl = post?.scrapedUrl;
  const newUrl = post?.formScreenshot;

  // console.log('post: ', post)
  console.log("url: ", newUrl);

  const handleClick = (event) => {
    event.stopPropagation();
    if (!newUrl) {
      window.open(scrapedUrl, "_blank");
    } else {
      dispatch({ type: "set_active_image", payload: newUrl });
    }
  };

  if (inView) {
    return <ImageModal imageUrl={newUrl} />;
  }

  if (text) {
    return (
      <Popup
        content="View Application Form"
        trigger={
          <div rel="noopener noreferrer" onClick={handleClick}>
            {!icon ? (
              <Button
                circular
                icon="eye"
                color="blue"
                size="small"
              >
                {text}
              </Button>
            ) : (
              icon
            )}
          </div>
        }
      />
    );
  }

  if (mini) {
    return (
      <Popup
        content="View Application Form"
        trigger={
          <div rel="noopener noreferrer" onClick={handleClick}>
            {!icon ? (
              <Button
                circular
                icon="eye"
                color="blue"
                size="mini"
              />
            ) : (
              icon
            )}
          </div>
        }
      />
    );
  }

  return (
    <Popup
      content="View Application Form"
      trigger={
        <div rel="noopener noreferrer" onClick={handleClick}>
          {!icon ? (
            <Button
              circular
              icon="eye"
              color="blue"
              size="small"
            />
          ) : (
            icon
          )}
        </div>
      }
    />
  );
}
